// region 1. Platform Libraries
import { createContext } from 'react';
// endregion

const ContextStore = createContext();

export default ContextStore;
